import React from 'react';
import ReactDOM from 'react-dom/client';
import { Provider } from 'react-redux';
import { PersistGate } from 'redux-persist/integration/react';
import { BrowserRouter as Router } from 'react-router-dom';
import { ClerkProvider } from '@clerk/clerk-react'
import './index.css';
import App from './App';
import { LoadingProvider } from './components/Auth/LoadingProvider';
import LoadingSpinner from './components/Shared/LoadingSpinner';
import { store, persistor } from './store';
import reportWebVitals from './reportWebVitals';

const PUBLISHABLE_KEY = process.env.REACT_APP_CLERK_PUBLISHABLE_KEY

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
      <Provider store={store}>
        <PersistGate loading={<LoadingSpinner />} persistor={persistor}>
          <Router>
            <ClerkProvider publishableKey={PUBLISHABLE_KEY}>
              <LoadingProvider>
                <App />
              </LoadingProvider>
            </ClerkProvider>
          </Router>
        </PersistGate>
      </Provider>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
// Store cleanup function to disconnect PerformanceObservers on unmount
let webVitalsCleanup = null;
reportWebVitals(() => {}).then(cleanup => {
  if (cleanup) webVitalsCleanup = cleanup;
});

// Cleanup on page unload (for development hot-reloads and navigation)
if (typeof window !== 'undefined') {
  window.addEventListener('beforeunload', () => {
    if (webVitalsCleanup) {
      webVitalsCleanup();
    }
  });
}
